export function isGraphPointer(arg) {
    return !!arg?.term;
}
export function isResource(arg) {
    return arg?.term?.termType === 'BlankNode' || arg?.term?.termType === 'NamedNode';
}
export function isNamedNode(arg) {
    return arg?.term?.termType === 'NamedNode';
}
export function isBlankNode(arg) {
    return arg?.term?.termType === 'BlankNode';
}
export function isLiteral(arg, dtOrLang) {
    const itIsLiteral = arg?.term?.termType === 'Literal';
    if (itIsLiteral && typeof dtOrLang === 'string') {
        return arg?.term.language === dtOrLang;
    }
    if (itIsLiteral && typeof dtOrLang === 'object') {
        return arg?.term.datatype.equals(dtOrLang);
    }
    return itIsLiteral;
}
export default {
    isGraphPointer,
    isResource,
    isNamedNode,
    isBlankNode,
    isLiteral,
};
